module.exports = function getResource(label) {
    let resources = { addPromo: 'Ajouter la promo' };
    return resources[label];
};
